module.exports = __webpack_public_path__ + "static/media/lock-open-alt.cb4d6532.svg";